import axios from "axios";
import constants from "../../utils/constants";

const API_URL = constants.FIXCON;

const tradeCaptureReportRequest = (client, instance, request) => {
    return axios.post(`${API_URL}/bymaCon/tradeCaptureReportRequest?client=${client}&instance=${instance}`, request);
};


const fixConsulta = {
    tradeCaptureReportRequest,    
}

export default fixConsulta;
